import { render } from "./SaveButton.vue?vue&type=template&id=66d7ca34"
import script from "./SaveButton.vue?vue&type=script&lang=js"
export * from "./SaveButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__